import {FilterSection} from "./FilterSection";
import {useCatalogFacade} from "../application/useCatalogFacade";
import {RemoteDataUI} from "../../../common/ui/RemoteDataUI";
import {Spinner} from "react-bootstrap";
import React from "react";
import {PaginatedCatalog} from "./PaginatedCatalog";
import {useFilterUrlSync} from "../application/useFilterUrlSync";

export const CatalogPage = () => {
    useFilterUrlSync();

    const {
        catalogRemoteData,
        filterOptionsRemoteData,
        filter,
        viewMode,
        onFilterChange,
        onPageChange,
        onViewModeChange
    } = useCatalogFacade();

    return (
        <div className="container">
            <div className="row">
                <aside className="col-12 col-lg-3 mb-4">
                    <RemoteDataUI remoteData={filterOptionsRemoteData}>
                        <RemoteDataUI.Pending>
                            <div className="text-center"><Spinner/></div>
                        </RemoteDataUI.Pending>

                        <RemoteDataUI.Failure>
                            <div className="alert alert-danger">
                                Imposible cargar Filtros. Intentelo más tarde.
                            </div>
                        </RemoteDataUI.Failure>;

                        <RemoteDataUI.Success>
                            {filterOptions =>
                                <FilterSection
                                    filterOptions={filterOptions}
                                    filter={filter}
                                    viewMode={viewMode}
                                    onFilterChange={onFilterChange}
                                    onViewModeChange={onViewModeChange}
                                />
                            }
                        </RemoteDataUI.Success>
                    </RemoteDataUI>

                </aside>
                <main className="col-12 col-lg-9 p-0">
                    <RemoteDataUI remoteData={catalogRemoteData}>
                        <RemoteDataUI.Pending>
                            <div className="text-center"><Spinner/></div>
                        </RemoteDataUI.Pending>

                        <RemoteDataUI.Failure>
                            <div className="alert alert-danger">
                                Imposible cargar productos. Intentelo más tarde.
                            </div>
                        </RemoteDataUI.Failure>;

                        <RemoteDataUI.Success>
                            {catalog =>
                                <PaginatedCatalog catalog={catalog} viewMode={viewMode} onPageChange={onPageChange}/>
                            }
                        </RemoteDataUI.Success>
                    </RemoteDataUI>

                </main>
            </div>
        </div>
    )
};